import {
	DELETE_TEAM,
	FETCH_V4_TEAMS,
	SAVE_TEAM,
	V4_TEAMS_LOADED,
} from '../constants/team.constants';

export const deleteTeam = team => ({ type: DELETE_TEAM, team });
export const saveTeam = team => ({ type: SAVE_TEAM, team});
export const fetchV4Teams = (account) => ({ type: FETCH_V4_TEAMS, account });
export const v4TeamsLoaded = (teams) => ({ type: V4_TEAMS_LOADED, teams });